'use client';
import { Col, Container, Placeholder, Row } from 'react-bootstrap';

export default function ThemeSkeleton() {
  return (
    <Container>
      <Row>
        <Col md={3}>
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
        <Col md={9}>
          <Placeholder
            xs={12}
            style={{ height: '240px', marginBottom: '20px' }}
          />
          <Row>
            <Col md={3}>
              <Placeholder
                xs={12}
                style={{ height: '170px', marginBottom: '20px' }}
              />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col md={3}>
              <Placeholder
                xs={12}
                style={{ height: '170px', marginBottom: '20px' }}
              />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col md={3}>
              <Placeholder
                xs={12}
                style={{ height: '170px', marginBottom: '20px' }}
              />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col md={3}>
              <Placeholder
                xs={12}
                style={{ height: '170px', marginBottom: '20px' }}
              />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col md={3}>
              <Placeholder
                xs={12}
                style={{ height: '170px', marginBottom: '20px' }}
              />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
